import React, { useState, useEffect, useRef, useCallback } from "react";
import API from "../services/api";
import Sidebar from "./Sidebar";
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import "../styles/billing.css";
import ViewSale from "./ViewSale";


export default function Billing() {
    // View Switcher: 'billing' or 'history'
    const [view, setView] = useState("billing");

    // --- Billing States ---
    const [stocks, setStocks] = useState([]);
    const [billItems, setBillItems] = useState([]);
    const [customer, setCustomer] = useState({ name: "", mobile: "" });
    const [searchTerm, setSearchTerm] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const componentRef = useRef();

    // --- ✨ New Paid & Due States ---
    const [paidAmount, setPaidAmount] = useState(0);
    const [discount, setDiscount] = useState(0);

    const [selectedProduct, setSelectedProduct] = useState(null);

    const [variantSearch, setVariantSearch] = useState("");

    // new code for search type in products and pagination start

    const [productPage, setProductPage] = useState(1);
    const itemsPerPageProduct = 12;


    const getQty = (q) => {
        const num = parseFloat(q);
        return isNaN(num) ? 0 : num;
    };


    //   new code for search type in products and pagination end

    const fetchStocks = useCallback(async () => {
        try {
            const res = await API.get("/stock");
            setStocks(res.data);
        } catch (err) { console.error("Stock error", err); }
    }, []);



    useEffect(() => {
        const searchCustomer = async () => {
            if (customer.mobile.length === 10) {
                try {
                    const res = await API.get(`/billing/customer/${customer.mobile}`);
                    if (res.data.success) {
                        setCustomer(prev => ({ ...prev, name: res.data.name }));
                        Swal.fire({
                            title: `Welcome Back, ${res.data.name}!`,
                            icon: 'success', toast: true, position: 'top-right',
                            timer: 2000, showConfirmButton: false
                        });
                    }
                } catch (err) {
                    // console.log("Naya Customer");

                    Swal.fire({
                        title: `New User ! Welcome`,
                        icon: 'warning', toast: true, position: 'top-right',
                        timer: 2000, showConfirmButton: false
                    });
                }
            }
        };
        searchCustomer();
    }, [customer.mobile]);



    useEffect(() => {
        fetchStocks();
    }, [fetchStocks]);


    const removeOne = (id) => {

        const existing = billItems.find(i => i.productId === id)

        if (!existing) return

        if (existing.qty > 1) {

            setBillItems(
                billItems.map(i =>
                    i.productId === id
                        ? { ...i, qty: i.qty - 1 }
                        : i
                )
            )

        } else {

            setBillItems(
                billItems.filter(i => i.productId !== id)
            )

        }

    }

    // --- ✨ Calculations ---
    // const total = billItems.reduce((acc, i) => acc + (i.price * i.qty), 0);
    // const dueAmount = total - paidAmount;
    const total = billItems.reduce(
        (acc, i) => acc + (Number(i.price) * Number(i.qty)),
        0
    );
    const finalTotal = Math.max(total - discount, 0);
    const dueAmount = finalTotal - paidAmount;


    const generateBillPDF = () => {
        const doc = new jsPDF("p", "mm", "a4");

        const money = (amount) => `Rs. ${Number(amount || 0).toFixed(2)}`;

        doc.setFillColor(15, 23, 42);
        doc.rect(0, 0, 210, 32, "F");

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(20);
        doc.text("BHOPAL SEAT COVER", 14, 14);

        doc.setFontSize(10);
        doc.text("Premium Car Interior & Accessories", 14, 23);

        doc.setTextColor(0, 0, 0);

        autoTable(doc, {
            startY: 40,
            theme: "grid",
            head: [["Customer Details", "Bill Details"]],
            body: [
                [`Name: ${customer.name || "Walking Customer"}`, `Date: ${new Date().toLocaleDateString("en-IN")}`],
                [`Mobile: ${customer.mobile || "N/A"}`, `Invoice No: BSC-${Math.floor(Math.random() * 9000) + 1000}`],
            ],
            headStyles: {
                fillColor: [15, 23, 42],
                textColor: 255,
            },
            styles: {
                fontSize: 9,
                cellPadding: 3,
            },
        });

        const itemRows = billItems.map((item, index) => {
            const qty = Number(item.qty || 0);
            const price = Number(item.price || 0);

            return [
                index + 1,
                item.name || "-",
                `${qty} ${item.unit || ""}`,
                money(price),
                money(qty * price),
            ];
        });

        autoTable(doc, {
            startY: (doc.lastAutoTable?.finalY || 40) + 8,
            theme: "striped",
            head: [["#", "Item", "Qty / Unit", "Rate", "Amount"]],
            body: itemRows,
            headStyles: {
                fillColor: [37, 99, 235],
                textColor: 255,
            },
            styles: {
                fontSize: 9,
                cellPadding: 3,
            },
            columnStyles: {
                0: { cellWidth: 12, halign: "center" },
                1: { cellWidth: 78 },
                2: { cellWidth: 28, halign: "center" },
                3: { cellWidth: 30, halign: "right" },
                4: { cellWidth: 32, halign: "right" },
            },
        });

        autoTable(doc, {
            startY: (doc.lastAutoTable?.finalY || 40) + 8,
            theme: "grid",
            body: [
                ["Subtotal", money(total)],
                ["Discount", money(discount)],
                ["Total", money(finalTotal)],
                ["Paid", money(paidAmount)],
                ["Due", money(dueAmount)],
                ["Status", dueAmount > 0 ? "UNPAID" : "PAID"],
            ],
            styles: {
                fontSize: 10,
                cellPadding: 3,
            },
            columnStyles: {
                0: { fontStyle: "bold", cellWidth: 130 },
                1: { halign: "right", cellWidth: 50 },
            },
        });

        const y = (doc.lastAutoTable?.finalY || 220) + 12;

        doc.setFontSize(11);
        doc.text("Thank you for choosing Bhopal Seat Cover!", 14, y);
        doc.setFontSize(9);
        doc.text("Visit again for premium car accessories.", 14, y + 6);

        doc.save(`${customer.name || "Customer"}_Bill.pdf`);
    };


    const finalizeBill = async () => {
        if (!customer.name.trim()) {
            return Swal.fire({ title: "Naam likho!", icon: "error", timer: 2000, showConfirmButton: false });
        }

        if (billItems.length === 0) {
            return Swal.fire({ title: "Items add karein!", icon: "warning" });
        }

        // 🔥 Due validation
        if (dueAmount > 0 && (!customer.mobile || customer.mobile.length < 10)) {
            return Swal.fire({
                title: "Mobile Number Required!",
                text: "Udhaar (Due) ke liye mobile number zaroori hai.",
                icon: "warning"
            });
        }

        try {
            const res = await API.post("/billing/generate", {
                customerName: customer.name,
                customerMobile: customer.mobile || "N/A",
                items: billItems,

                // 🔥 IMPORTANT: correct values
                subTotal: Number(total),
                discount: Number(discount || 0),
                totalAmount: Number(finalTotal),
                paidAmount: Number(paidAmount),
                dueAmount: Number(dueAmount)
            });

            if (res.data.success) {
                if (customer.mobile && customer.mobile.length >= 10) {
                    const pdfConfirm = await Swal.fire({
                        title: 'Generate PDF?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });

                    if (pdfConfirm.isConfirmed) {
                        generateBillPDF();

                        const waConfirm = await Swal.fire({
                            title: 'WhatsApp?',
                            icon: 'success',
                            showCancelButton: true
                        });

                        if (waConfirm.isConfirmed) {
                            const itemText = billItems.map((item, index) => {
                                return `${index + 1}. ${item.name} - ${item.qty} ${item.unit || ""} x ₹${item.price} = ₹${item.qty * item.price}`;
                            }).join("%0A");
                            const msg =
                                `Bhopal Seat Cover%0A%0A` +
                                `Customer: ${customer.name}%0A` +
                                `Mobile: ${customer.mobile || "N/A"}%0A%0A` +
                                `Items:%0A${itemText}%0A%0A` +
                                `Subtotal: ₹${total}%0A` +
                                `Discount: ₹${discount}%0A` +
                                `Total: ₹${finalTotal}%0A` +
                                `Paid: ₹${paidAmount}%0A` +
                                `Due: ₹${dueAmount}%0A%0A` +
                                `PDF bill downloaded. Please attach/send it on WhatsApp.%0A%0A` +
                                `Thank You!`;

                            window.open(
                                `https://wa.me/91${customer.mobile}?text=${msg}`,
                                "_blank"
                            );
                        }
                    }
                }

                Swal.fire({ title: "Bill Saved!", icon: "success", timer: 1500 });

                // 🔥 Reset
                setBillItems([]);
                setCustomer({ name: "", mobile: "" });
                setPaidAmount(0);
                setDiscount(0);
                fetchStocks();
            }
        } catch (err) {
            Swal.fire({ title: "Error", icon: "error" });
        }
    };


    const filteredStocks = stocks.filter(item =>
        item.name
            ?.toLowerCase()
            .replace(/\s+/g, " ")
            .includes(searchTerm.toLowerCase().trim())
    );

    const groupedProducts = Object.values(
        filteredStocks.reduce((acc, item) => {

            if (!acc[item.name]) {
                acc[item.name] = {
                    name: item.name,
                    price: item.price,
                    desk: item.desk,
                    brand: item.brand,
                    model: item.model,
                    items: []
                };
            }

            acc[item.name].items.push(item);

            return acc;

        }, {})
    );

    useEffect(() => {
        setProductPage(1);
    }, [searchTerm]);


    // PRODUCT PAGINATION
    const totalProductPages = Math.ceil(groupedProducts.length / itemsPerPageProduct);

    const paginatedProducts = groupedProducts.slice(
        (productPage - 1) * itemsPerPageProduct,
        productPage * itemsPerPageProduct
    );


    const addToBill = (product) => {

        const existing = billItems.find(i => i.productId === product._id)

        const currentQty = existing ? existing.qty : 0


        if (currentQty >= getQty(product.quantity)) {
            Swal.fire({
                title: "Stock Limit Reached",
                text: `Sirf ${product.quantity} hi available hai`,
                icon: "warning",
                timer: 1500,
                showConfirmButton: false
            })
            return
        }

        if (existing) {
            setBillItems(
                billItems.map(i =>
                    i.productId === product._id
                        ? { ...i, qty: i.qty + 1 }
                        : i
                )
            )
        } else {
            setBillItems([
                ...billItems,
                {
                    productId: product._id,
                    name: product.name,
                    price: product.price,
                    qty: 1,
                    unit: product.unit
                }
            ])
        }
    }


    return (
        <div className="dashboard-layout">
            <Sidebar />
            <div className="main-content bsc-premium-bg">
                <div className="portal-header-action">
                    <h2 className="title-glow">{view === "billing" ? "Quick Billing Portal" : "Sales History Report"}</h2>
                    <button className="bsc-toggle-btn" onClick={() => setView(view === "billing" ? "history" : "billing")}>
                        {view === "billing" ? "📊 View Sales" : "➕ Create Bill"}
                    </button>
                </div>

                {view === "billing" ? (
                    <div className="billing-grid-final">
                        <div className="selection-side">
                            <div className="top-input-row">
                                <div className="input-box">
                                    <i className="fab fa-whatsapp icon-fix"></i>
                                    <input type="text" placeholder="Mobile Number" value={customer.mobile} onChange={(e) => setCustomer({ ...customer, mobile: e.target.value })} />
                                </div>
                                <div className="input-box">
                                    <i className="fas fa-user icon-fix"></i>
                                    <input type="text" placeholder="Customer Name" value={customer.name} onChange={(e) => setCustomer({ ...customer, name: e.target.value })} />
                                </div>
                            </div>

                            {/* <div className="search-wrapper-final">
                                {!isFocused && !searchTerm && <span className="search-placeholder">🔍 Search items...</span>}
                                <input type="text" onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} onChange={(e)=>setSearchTerm(e.target.value)} />
                            </div> */}

                            {/* new code start for search bar */}

                            <div className="search-wrapper-final">

                                {!isFocused && !searchTerm && (
                                    <span className="search-placeholder">🔍 Search items...</span>
                                )}

                                <input
                                    type="text"
                                    value={searchTerm}
                                    onFocus={() => setIsFocused(true)}
                                    onBlur={() => setIsFocused(false)}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />

                                {/* new code end for search bar */}

                            </div>

                            <div className="bsc-stock-container">
                                {paginatedProducts.map(product => {

                                    const brandCount = new Set(product.items.map(i => i.brand)).size
                                    const modelCount = new Set(product.items.map(i => i.model)).size

                                    return (

                                        <div
                                            key={product.name}
                                            className="bsc-modern-card"
                                            onClick={() => setSelectedProduct(product)}
                                        >

                                            <h4>{product.name}</h4>

                                            <p className="brand-count">
                                                Brands: {brandCount}
                                            </p>

                                            <p className="model-count">
                                                Models: {modelCount}
                                            </p>

                                        </div>

                                    )
                                })}
                            </div>

                            <div className="bsc-product-pagination">
                                <button
                                    disabled={productPage === 1}
                                    onClick={() => setProductPage(productPage - 1)}
                                >
                                    Prev
                                </button>

                                <span>
                                    Page {productPage} of {totalProductPages || 1}
                                </span>

                                <button
                                    disabled={
                                        productPage === totalProductPages ||
                                        totalProductPages === 0
                                    }
                                    onClick={() => setProductPage(productPage + 1)}
                                >
                                    Next
                                </button>
                            </div>

                        </div>
                        <div className="preview-side">
                            <div className="real-invoice-paper" ref={componentRef}>
                                {/* Header Decor */}
                                <div className="invoice-top-bar"></div>

                                <div className="invoice-header-center">
                                    <h1 className="brand-name">BHOPAL SEAT COVER</h1>
                                    <p className="brand-subtitle">Premium Car Interior & Accessories</p>
                                    <div className="fancy-divider">
                                        <span><i className="fas fa-star"></i></span>
                                    </div>
                                </div>

                                <div className="customer-meta-grid">
                                    <div className="meta-item">
                                        <span className="label">CUSTOMER</span>
                                        <span className="value">{customer.name || "Walking Customer"}</span>
                                    </div>
                                    <div className="meta-item text-end">
                                        <span className="label">DATE</span>
                                        <span className="value">{new Date().toLocaleDateString('en-GB')}</span>
                                    </div>
                                    <div className="meta-item">
                                        <span className="label">CONTACT</span>
                                        <span className="value">{customer.mobile || "N/A"}</span>
                                    </div>
                                    <div className="meta-item text-end">
                                        <span className="label">INVOICE NO.</span>
                                        <span className="value">#BSC-{Math.floor(Math.random() * 9000) + 1000}</span>
                                    </div>
                                </div>

                                <table className="premium-bill-table">
                                    <thead>
                                        <tr>
                                            <th>DESCRIPTION</th>
                                            <th className="text-center">QTY</th>
                                            <th className="text-end">AMOUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {billItems.map((item, idx) => (
                                            <tr key={idx} className="bill-row">
                                                <td>
                                                    <div className="item-name-wrapper">
                                                        <span className="item-name">
                                                            {item.name} ({item.unit || ""})
                                                        </span>
                                                        <button className="remove-item-btn no-print" onClick={(e) => { e.stopPropagation(); removeOne(item.productId); }}>
                                                            <i className="fas fa-minus-circle"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    × {item.qty} {item.unit || ""}
                                                </td>
                                                <td className="text-end">₹{(item.price * item.qty).toLocaleString()}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div className="invoice-footer-section">
                                    <div className="billing-summary-box">


                                        <div className="summary-line">
                                            <span>Subtotal</span>
                                            <span>₹{total.toLocaleString()}</span>
                                        </div>

                                        {/* 🔥 DISCOUNT INPUT */}
                                        <div className="summary-line">
                                            <span>Discount</span>
                                            <div className="input-with-currency">
                                                <span>₹</span>
                                                <input
                                                    type="number"
                                                    value={discount}
                                                    onChange={(e) => setDiscount(Number(e.target.value))}
                                                    min="0"
                                                />
                                            </div>
                                        </div>

                                        {/* 🔥 TOTAL (READ ONLY) */}
                                        <div className="summary-line">
                                            <span>Total</span>
                                            <div className="input-with-currency">
                                                <span>₹</span>
                                                <input
                                                    type="number"
                                                    value={finalTotal}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="summary-line highlight-paid">
                                            <span>Paid Amount</span>
                                            <div className="input-with-currency">
                                                <span>₹</span>
                                                <input
                                                    type="number"
                                                    value={paidAmount}
                                                    max={finalTotal}
                                                    onChange={(e) => {

                                                        const value = Number(e.target.value)

                                                        if (value > finalTotal) {

                                                            Swal.fire({
                                                                title: "Invalid Amount",
                                                                text: `Total ₹${finalTotal} se zyada pay nahi kar sakte`,
                                                                icon: "warning",
                                                                timer: 1500,
                                                                showConfirmButton: false
                                                            })

                                                            setPaidAmount(finalTotal)

                                                        } else {

                                                            setPaidAmount(value)

                                                        }

                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className={`summary-line total-line ${dueAmount > 0 ? 'has-due' : ''}`}>
                                            <span>{dueAmount > 0 ? "Balance Due" : "Total Amount"}</span>
                                            {/* <span>₹{dueAmount > 0 ? dueAmount.toLocaleString() : total.toLocaleString()}</span> */}
                                            <span>₹{dueAmount > 0 ? dueAmount.toLocaleString() : finalTotal.toLocaleString()}</span>

                                        </div>
                                    </div>

                                    <div className="thank-you-msg">
                                        <p>Thank you for choosing Bhopal Seat Cover!</p>
                                        <small>Visit again for premium car accessories.</small>
                                    </div>
                                </div>
                            </div>

                            <button className="bsc-premium-action-btn" onClick={finalizeBill}>
                                <i className="fas fa-check-double"></i>
                                {dueAmount > 0 ? "CONFIRM DUE BILL" : "CONFIRM & PRINT"}
                            </button>
                        </div>
                    </div>
                ) : (
                    // viewsale page

                    <ViewSale setView={setView} />

                )}


                {selectedProduct && (

                    <div
                        className="product-modal-overlay bsc-premium-bg"
                        onClick={(e) => {
                            if (e.target.classList.contains("product-modal-overlay")) {
                                return;
                            }
                        }}
                    >
                        <div className="product-modal">

                            <div className="modal-header">

                                <h3>{selectedProduct.name} Variants</h3>

                                <button
                                    className="close-btn"
                                    onClick={() => {
                                        setSelectedProduct(null)
                                        setVariantSearch("")
                                    }}
                                >
                                    ✕
                                </button>

                            </div>

                            <input
                                className="variant-search"
                                placeholder="Search brand or model..."
                                value={variantSearch}
                                onChange={(e) => setVariantSearch(e.target.value)}

                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {

                                        const first = selectedProduct.items.find(item =>
                                            (item.brand + " " + item.model)
                                                .toLowerCase()
                                                .includes(variantSearch.toLowerCase())
                                        )

                                        if (first) {
                                            addToBill(first)
                                        }

                                    }
                                }}
                            />

                            <div className="variant-grid">

                                {selectedProduct.items
                                    .filter(item =>
                                        (item.brand + " " + item.model)
                                            .toLowerCase()
                                            .includes(variantSearch.toLowerCase())
                                    )
                                    .map(item => {


                                        const itemInBill = billItems.find(i => i.productId === item._id)
                                        const qty = itemInBill ? itemInBill.qty : 0

                                        return (

                                            <div
                                                key={item._id}
                                                className="variant-card"
                                            >

                                                <h4>{item.brand}</h4>
                                                <p>{item.model}</p>


                                                <h4>Desk: {item.desk || "N/A"}</h4>

                                                <div className="variant-bottom">

                                                    <span
                                                        className="stock"
                                                        style={{
                                                            color: getQty(item.quantity) <= 3 ? "#ef4444" : "#22c55e",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        Stock : {item.quantity} {item.unit || "N/A"}

                                                        {getQty(item.quantity) <= 3 && (
                                                            <span className="low-stock"> LOW</span>
                                                        )}

                                                    </span>


                                                    <span className="price">₹{item.price}</span>

                                                </div>

                                                <br />

                                                <div className="qty-control">

                                                    <button
                                                        className="minus-btn"
                                                        disabled={qty === 0}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            removeOne(item._id)
                                                        }}
                                                    >
                                                        -
                                                    </button>

                                                    <span className="qty-number text-red">{qty}</span>

                                                    <button
                                                        className="add-btn"
                                                        disabled={qty >= getQty(item.quantity)}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            addToBill(item)
                                                        }}
                                                    >
                                                        +
                                                    </button>

                                                </div>

                                            </div>

                                        )
                                    })}


                            </div>

                            <div className="modal-footer">

                                <button
                                    className="cancel-btn"
                                    onClick={() => {
                                        setSelectedProduct(null)
                                        setVariantSearch("")
                                    }}
                                >
                                    Cancel
                                </button>

                            </div>

                        </div>

                    </div>

                )}


            </div>


        </div >
    );
}